export const SAMPLE_ID_LENGTH = 38;
